import * as moment from 'moment';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {
  CancellationOrderDialogComponent
} from '../common/cancellation-order-dialog/cancellation-order-dialog.component';
import {Column, TableConfig, Types} from './table-config';
import {CommonService} from '../services/common.service';
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {
  EditLoadingOrderSerialNumberComponent
} from '../common/edit-loading-order-serial-number/edit-loading-order-serial-number.component';
import {ExportCsvService} from '../services/export-csv.service';
import {FilterTableDialogComponent} from './filter-table-dialog/filter-table-dialog.component';
import {HttpClient} from '@angular/common/http';
import {
  InventoryRefrigeratorsDialogComponent
} from '../inventory-details/inventory-refrigerators-dialog/inventory-refrigerators-dialog.component';
import {LoadingService} from '../services/loading.service';
import {LocalStorageService} from '../services/local-storage.service';
import {
  MatDialog,
  MatMenuTrigger,
  MatPaginator,
  MatSnackBar,
  MatSort,
  SortDirection
} from '@angular/material';
import {RefrigeratorsService} from '../services/refrigerators.service';
import {
  SimpleConfirmActionDialogComponent
} from '../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {TableFiltersService} from '../services/table-filters.service';
import {ToastMessagesService} from '../services/toast-messages.service';
import {
  UpdateSerialNumberDialogComponent
} from '../common/update-serial-number-dialog/update-serial-number-dialog.component';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {merge, of as observableOf, Subscription} from 'rxjs';

import RefrigeratorsConfig from './configs/inventory-refrigerators.json';

@Component({
  selector: 'app-table',
  styleUrls: ['./table.component.scss'],
  templateUrl: './table.component.html'
})
export class TableComponent implements OnInit {
  @Input() inputConfig: any;
  @ViewChild(MatMenuTrigger, {static: false}) contextMenu: MatMenuTrigger;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public config: TableConfig;
  public contextMenuPosition: any;
  public data: any[];
  private displayedColumns: string[];
  private filter: string;
  public filterChips: any[];
  private filterTableDialogFilter: string;
  public filterValues: any[];
  private firstCache: boolean;
  public imageFilesSource: any;
  private initialFilter: string;
  private initializeFilters: boolean;
  public inventoryRefrigeratorRow: any;
  public inventoryRefrigeratorSerialNumber: string;
  private isColumnSet: boolean;
  public isLoading: boolean;
  private orderDetails: any;
  private orderDetailsId: number;
  private orderDetailsSerials: any;
  public pageSize: number;
  private purchaseOrderDetails: any;
  public resultsLength: number;
  public rowInitialized: boolean;
  private searchFilter: string;
  public searchValue: string;
  public selectedColumns: any;
  public showInsertButton: boolean;
  private user: any;

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private commonService: CommonService,
              private exportCsvService: ExportCsvService,
              private httpClient: HttpClient,
              private loadingService: LoadingService,
              private localStorageService: LocalStorageService,
              private matDialog: MatDialog,
              private matSnackBar: MatSnackBar,
              private refrigeratorsService: RefrigeratorsService,
              private router: Router,
              private tableFiltersService: TableFiltersService,
              private toastMessagesService: ToastMessagesService) {
    this.contextMenuPosition = {x: '0px', y: '0px'};
    this.data = [];
    this.displayedColumns = [];
    this.filterTableDialogFilter = '';
    this.imageFilesSource = [];
    this.initializeFilters = false;
    this.isColumnSet = false;
    this.isLoading = true;
    this.pageSize = 25;
    this.resultsLength = 0;
    this.searchFilter = '';
    this.searchValue = '';
    this.orderDetailsSerials = {};
  }

  public async ngOnInit(): Promise<any> {
    this.activatedRoute.data.subscribe((data) => {
      if (data.config) {
        this.config = Object.assign({}, data.config);
      } else {
        this.config = Object.assign({}, this.inputConfig);
      }
    });
    this.activatedRoute.params.subscribe(async (params) => {
      this.orderDetailsId = params.id;
      if (this.config.model === 'loading_command/web/details/serial_numbers') {
        this.orderDetailsSerials = await this.commonService.getSimpleList(`loading_command/web/basic_info/${params.id}`);
      }
    });
    await this.initUser();
    this.purchaseOrderDetails = JSON.parse(localStorage.getItem('purchaseOrder'));
    this.orderDetails = JSON.parse(localStorage.getItem('orderDetails'));


    if (this.config.insertButtonText) {
      const roles = this.config.insertRole.split(',');
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < roles.length; i++) {
        if (this.authService.isUserBelongsTo(roles[i])) {
          if (this.authService.isUserInternal(this.config)) {
            this.showInsertButton = true;
            break;
          }
        }
      }
    }

    if (this.config.insertRepairButtonText) {
      if (this.authService.isUserInternal(this.config)) {
        this.showInsertButton = true;
      }
    }

    if (this.config.insertLink) {
      if (this.config.insertLink  === 'maintenance-form' && this.user.role_alternate_name === 'hqManager') {
        this.showInsertButton = false;
      }
    }

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.config.columns.length; i++) {
      this.displayedColumns.push(this.config.columns[i].name);
    }

    if (this.config.model === 'inventory_refrigerator' || this.config.model === 'request/web') {
      const existInDisplayColumns = this.displayedColumns.findIndex(c => c === 'actions2');
      if (existInDisplayColumns === -1) {
        this.displayedColumns.push('actions2');
      }
      const existInConfig = this.config.columns.findIndex(c => c.name === 'actions2');

      if (existInConfig === -1) {
        this.config.columns.push({
          name: 'actions2',
          title: 'Ενέργειες',
          type: Types.text,
          filteredSelect: undefined,
          fromValue: '',
          select: undefined,
          selectFilterControl: undefined,
          selectPlaceholder: '',
          selected: [],
          sort: false,
          text: '',
          toValue: ''
        });
      }
    }

    if (this.config.filter) {
      this.initialFilter = this.config.filter;
    } else {
      if (this.config.model === 'promo_material_request/web/details') {
        this.initialFilter = `request_id=${this.orderDetailsId}`;
      } else {
        this.initialFilter = '';
      }
    }

    this.paginator = this.commonService.setPaginatorTexts(this.paginator);

    if (this.config.orderColumn) {
      this.sort.active = this.config.orderColumn;

      this.sort.direction = this.config.orderDirection as SortDirection;
    }

    this.sort.sortChange.subscribe(() => {
      // this.loadingService.show();

      this.paginator.pageIndex = 0;
    });

    this.paginator.page.subscribe(() => {
      // this.loadingService.show();
    });

    this.checkForCachedSortingPagingFilters();

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          let customFilters;
          const sortingFilter = {
            direction: this.sort.direction !== '' ? this.sort.direction : '',
            columnName: this.sort.active && this.sort.direction ? this.sort.active : null,
          };
          this.sort.active = sortingFilter.columnName;

          const pagingFilter = {
            index: this.paginator.pageIndex ? this.paginator.pageIndex : 0,
            size: this.paginator.pageSize ? this.paginator.pageSize : 25
          };
          customFilters = this.getCustomFiltersFromLocalStorage();
          if (!customFilters) {
            customFilters = {
              sortingFilter,
              pagingFilter,
              searchValue: ''
            };

          } else {
            customFilters.sortingFilter = sortingFilter;
            customFilters.pagingFilter = pagingFilter;
          }
          this.localStorageService.setItem(`filterSortPaginatingItem`, customFilters, this.config.model);

          return this.httpClient.get(this.initializeCallURL());
        }),
        map((data: any) => {
          this.resultsLength = data.total;
          if (this.config.model === 'loading_command/web/details/serial_numbers' || this.config.model === 'unloading_command/web/details/serial_numbers') {
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < data.value.length; i++) {
              const d = data.value[i];
              // tslint:disable-next-line:max-line-length
              d.stage_name = d.stage_id === 1 ? 'Προς Εκτέλεση' : d.stage_id === 2 ? 'Προς Αποστολή' : d.stage_id === 3 ? 'Απεσταλμένο' : d.stage_id === 4 ? 'Προς Παραλαβή' : 'Παραληφθέν';
            }
          }
          // this.loadingService.hide();
          this.isLoading = false;
          return data.value;
        }),
        catchError((e) => {
          this.loadingService.hide();
          return observableOf([]);
        })
      ).subscribe((data) => {
      this.data = data;
      if (this.filterChips && this.filterChips.length !== 0 && this.paginator.pageIndex === 0) {
        this.checkForCacheFilters();
      }

      if (!this.firstCache) {
        this.checkForCacheFilters();
      }

      const customFilters = this.getCustomFiltersFromLocalStorage();
      if (customFilters && customFilters.searchValue && customFilters.searchValue !== '') {
        this.searchValue = customFilters.searchValue;
        this.setSearchFilter();
      }

      this.setUpDisplayedColumns();
    });
  }

  public allowExport(): boolean {
    return this.config.allowExport;
  }

  private applyFilter(): Subscription {
    // if (this.searchValue === '') {
    //   this.paginator.pageIndex = 0;
    // }
    this.isLoading = true;
    this.data = [];
    // this.loadingService.show();
    return this.httpClient.get(this.initializeCallURL()).subscribe((data: any) => {
      this.resultsLength = data.total;
      this.data = data.value;
      this.isLoading = false;
      // this.loadingService.hide();
    }, error => {
      const e = error.error.error;
      this.toastMessages(`Δεν μπόρεσε να ολοκληρωθεί το αίτημα της αναζήτησής σας. Λόγος: ${e.code} - ${e.errno}`);
      this.isLoading = false;
    });
  }

  public async cancelInventory(element: any): Promise<any> {
    const refrigerator = {
      id: element.id,
      action: 'delete'
    };

    try {
      await this.commonService.updateObject(`inventory/web/refrigerator`, refrigerator);
      this.toastMessagesService.toastMessages(`Η ακύρωση ολοκληρώθηκε με επιτυχία`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  public cancelRow($event: any, element: any): void {
    $event.stopPropagation();

    const model = {
      commandId: this.orderDetails.order_id,
      loading_command_serial_number_details_id: element.id,
      orderTypeId: this.orderDetails.order_type_id, // 1 paraggelia | 2 aitisi
    };
    const dialog = this.matDialog.open(CancellationOrderDialogComponent, {
      width: '650px',
      data: {
        id: element.id,
        title: `Ακύρωση σειριακού εντολής φόρτωσης με αριθμό ${this.orderDetails.order_id}`,
        mode: 3,
        orderDetails: model,
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (result) {
        this.toastMessagesService.toastMessages('Η ακύρωση ολοκληρώθηκε με επιτυχία');
      }
    });
  }

  public changePageSize(): void {
    this.isLoading = true;
    this.pageSize = this.paginator.pageSize;
  }

  private checkForCacheFilters() {
    const result = this.localStorageService.getItem(`filterItem_${this.config.model}`);
    if (result && result.config && result.filter) {
      if (this.config.model === result.config.model) {
        this.config = Object.assign({}, result.config);
        this.filterTableDialogFilter = result.filter;
        this.searchFilter = '';
        this.searchValue = '';
        this.setFilterValues();
        this.applyFilter();
        this.firstCache = true;
      }
    }
  }

  private checkForCachedSortingPagingFilters() {
    try {
      const result = this.localStorageService.getItem(`filterSortPaginatingItem_${this.config.model}`);
      if (result) {
        this.sort.active = result.sortingFilter.columnName ? result.sortingFilter.columnName : '';
        this.sort.direction = result.sortingFilter.direction ? result.sortingFilter.direction : '';
        this.pageSize = result.pagingFilter.size;
        this.paginator.pageIndex = result.pagingFilter.index;
      }
    } catch (e) {
    }
  }

  public editBudgetRow($event: MouseEvent): void {
    $event.stopPropagation();
  }

  public editRow($event: any, element): void {
    $event.stopPropagation();

    const model = {
      materialId: this.orderDetailsSerials.material_id,
      serialNumber: element.serial_number,
      commandId: this.orderDetails.order_id,
      rowId: element.id
    };
    const editDialog = this.matDialog.open(EditLoadingOrderSerialNumberComponent, {
      width: '400px',
      height: '300px',
      disableClose: true,
      data: {
        title: 'Επεξεργασία σειριακού αριθμού',
        details: model
      }
    });

    editDialog.afterClosed().subscribe(result => {
      if (result) {
        this.toastMessagesService.toastMessages('Η επεξεργασία του σειριακού ολοκληρώθηκε με επιτυχία');
      }
    });
  }

  public equals(objOne, objTwo): boolean {
    if (typeof objOne !== 'undefined' && typeof objTwo !== 'undefined') {
      return objOne.title === objTwo.title;
    }
  }

  public async exportCSV(): Promise<void> {
    try {
      this.commonService.toggleCustomLoader(true);
      const data = await this.getDataForExport();
      if (this.config.model === 'super_market_budget') {
        let columns = this.config.columns;
        // @ts-ignore
        columns = [ ...columns.slice(0, 1), {name: 'material_id', title: 'Κωδικός Είδους', type: 'text' }, ...columns.slice(1)];
        this.config.columns = columns;
      }
      this.exportCsvService.generateCsv(data, this.config.title, this.config.columns);
    } catch (e) {
      this.toastMessages(e.message);
    } finally {
      this.commonService.toggleCustomLoader(false);

    }
    // this.httpClient.get(this.initializeCallURL('export')).subscribe((data: any) => {
    //   if (this.config.model === '') {
    //
    //   } else {
    //     this.exportCSVService.generateCsv(data, this.config.title, this.config.columns);
    //   }
    // });
  }

  public formatValue(value: any, column: any): string {
    switch (column.type) {
      case Types.date:
        return value ? this.commonService.formatDate(value) : '-';
      case Types.dateTime:
        return value ? this.commonService.formatDateTime(value) : '-';
      case Types.number:
        return value !== undefined ? value : '-';
      default:
        return value ? value : '-';
    }
  }

  private getCustomFiltersFromLocalStorage(): any {
    const result = this.localStorageService.getItem(`filterSortPaginatingItem_${this.config.model}`);
    if (result) {
      return result;
    } else {
      return null;
    }
  }

  private async getDataForExport(): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(this.initializeCallURL('export')).subscribe((data: any) => {
        resolve(data);
      });
    });
  }

  public getDisplayedColumns(): any[] {
    return this.isColumnSet ? this.selectedColumns.map(column => column.name) : [];
  }

  public async getRecord(row: any) {
    if (this.config.showRefrigerators) {
      // this.loadingService.show();

      const refrigeratorsConfig = RefrigeratorsConfig;

      refrigeratorsConfig.filter = `inventory_sale_point_id = ${row.id}`;

      this.matDialog.open(InventoryRefrigeratorsDialogComponent, {
        data: {
          refrigeratorsConfig
        }
      });
    } else if (this.config.model === 'event_log/sale_point'
      && row.log_type_id === 8) {
      await this.router.navigate([row.model, row.id]);
    }  else if (this.config.model === 'event_log' || this.config.model === 'event_log/agreement' || this.config.model === 'event_log/sale_point'
      || this.config.model === 'event_log/refrigerator') {
      await this.router.navigate([row.model, row.model_id]);
    } else if (this.config.model === 'refrigerator/transport_tracking') {
      await this.router.navigate([row.command_url, row.id]);
    } else if (this.config.navigatePath) {

      if (this.config.model === 'promo_material_request/web') {
        await localStorage.setItem('promoDetails', JSON.stringify(row));
      }

      if (this.config.model === 'purchase_orders') {
        await localStorage.setItem('purchaseOrder', JSON.stringify(row));
      }
      if (this.config.model === 'loading_command/web' || this.config.model === 'unloading_command/web') {
        const details = {
          loading_order_id: row.command_id,
          order_id: row.id, // row id
          order_id1: row.order_id, // arithmos pareggelias
          order_type_id: row.order_type_id, // apo pou proerxetai p.x aitisi | paraggelia
          desired_delivery_date: row.desired_delivery_date,
          sale_point_id: row.sale_point_id,
          user_id: row.user_id,
          recipient: row.sale_point_name,
          address: row.sale_point_address,
          loading_command_total_canceled_quantity: +row.loading_command_total_canceled_quantity,
          loading_command_total_quantity: +row.loading_command_total_quantity,
          request_type_id: row.request_type_id, // an proerxetai p.x apo simeio pwlisis eparxias | simeio pwlisis idiou diktyou
          status: row.status_id
        };
        await localStorage.setItem('orderDetails', JSON.stringify(details));
      }
      if (this.config.model === 'loading_command/web/details' || this.config.model === 'unloading_command/web/details') {
        const details = {
          order_id: this.orderDetails.order_id,
          material_id: row.material_id
        };
        await localStorage.setItem('orderDetailsSerials', JSON.stringify(details));
      }
      if (this.config.model === 'request/web') {
        const details = {
          requestId: row.id,
          status_id: row.status_description_id,
          type_id: row.type_id,
          sale_point_id: row.sale_point_id,
          sale_point_customer_name: row.sale_point_customer_name,
          sales_point_sales_group_name: row.sales_point_sales_group_name,
          sale_point_address: row.sale_point_address,
          customer_code: row.customer_code
        };
        localStorage.setItem('requestDetails', JSON.stringify(details));
      }
      if (this.config.model === 'return_command/web') {
        const details = {
          created_from_user_role_id: row.role_id,
          created_from_user_role_name: row.role_name,
          requestId: row.id,
          status_id: row.status_id,
          city: row.recipient_sale_point_city,
          recipient: row.recipient_sale_point_customer_name,
          typeId: row.type_id,
          cancel_reason_description: row.cancel_reason_description,
          cancel_reason_id: row.cancel_reason_id,
          applicant_name: row.applicant_sale_point_customer_name ? row.applicant_sale_point_customer_name : '-',
          applicant_sales_group: row.applicant_sale_point_sales_group ? row.applicant_sale_point_sales_group : '-',
          applicant_address: row.applicant_sale_point_address ? row.applicant_sale_point_address : '-',
          recipient_sales_group: row.recipient_sales_group ? row.recipient_sales_group : '-'
        };
        await localStorage.setItem('returnDetails', JSON.stringify(details));
      }
      await this.router.navigate([this.config.navigatePath, row[this.config.navigateProperty]]);
    } else if (this.config.model === 'inventory_refrigerator') {
      // this.loadingService.show();

      this.imageFilesSource = [];
      this.inventoryRefrigeratorRow = row;
      this.rowInitialized = true;
      const filter = `inventory_refrigerator_id=${row.id}`;
      this.commonService.getListWithParameters('inventory_refrigerator_file', filter).then((files: any) => {

        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < files.length; i++) {
          const imageFile = `${environment.apiUrl}files?name=${files[i].file_name}`;
          this.imageFilesSource.push(imageFile);
        }
        this.loadingService.hide();
      });
    }
  }

  private getSelectedColumns(): any[] {
    const columns = this.localStorageService.getItem(`selectedColumns_${this.config.model}`);
    if (columns) {
      return columns;
    } else {
      return null;
    }
  }

  private initializeCallURL(mode?: string): string {
    let query = '';

    query = `${this.config.model}?count=true`;

    if (mode !== 'export') {
      query += `&limit=${this.pageSize}&skip=${this.pageSize * this.paginator.pageIndex}`;
    }

    this.filter = this.initialFilter;

    if (this.searchFilter !== '') {
      this.filter = `${this.filter === '' ? '' : `${this.filter} AND `}(${this.searchFilter})`;
    }

    if (this.filterTableDialogFilter !== '') {
      this.filter = `${this.filter === '' ? '' : `${this.filter} AND `}(${this.filterTableDialogFilter})`;
    }

    if (this.filter) {
      query += `&filter=${this.filter}`;
    }

    if (this.sort.active) {
      query += `&order=${this.sort.active} ${this.sort.direction}`;
    }

    if (this.config.model === 'request/web') {
      query += '&order=id asc';
    }

    if (this.config.model === 'po_details' && !this.filter) {
      query += `&filter=po_id=${this.purchaseOrderDetails.id}`;
    }

    if (this.config.model === 'po_details' && this.filter) {
      query += `AND po_id=${this.purchaseOrderDetails.id}`;
    }
    return query;
  }

  public initializeFilterTableDialog(): void {
    if (this.initializeFilters) {
      this.openFilterTableDialog();
    } else {
      this.commonService.toggleCustomLoader(true);

      let promises: Array<Promise<any>>;
      promises = [];

      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.config.columns.length; i++) {
        if (this.config.columns[i].type === Types.multipleSelect || this.config.columns[i].type === Types.select) {
          const promise = this.commonService.getList(this.config.columns[i].select.model).then((result: any) => {
            this.config.columns[i].select.options = result;
          });
          promises.push(promise);
        }
      }

      Promise.all(promises).then(() => {
        this.initializeFilters = true;
        this.openFilterTableDialog();
        this.commonService.toggleCustomLoader(false);
      });
    }
  }

  private async initUser(): Promise<any> {
    try {
      this.user = await this.authService.getUser();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  public isCancelButtonDisabled(element?: any): boolean {
    return !(this.orderDetails.order_type_id === 1 ||
        (this.orderDetails.order_type_id === 2 && this.orderDetails.request_type_id !== 7))
      || (this.orderDetails.loading_command_total_quantity - this.orderDetails.loading_command_total_canceled_quantity === 1) ||
      (element && element.is_canceled === 1);
  }

  public isEditCancelButtonDisabled(): boolean {
    return !((this.orderDetails.order_type_id === 1 ||
        (this.orderDetails.order_type_id === 2 && this.orderDetails.request_type_id !== 7)) &&
      this.orderDetailsSerials.material_id !== null);
  }

  public async navigateToForm(): Promise<any> {
    await this.router.navigate([this.config.insertLink]);
  }

  public async navigateToLoadingCommand(row, $event: Event): Promise<any> {
    $event.preventDefault();
    $event.stopPropagation();
    const link = this.router.serializeUrl(this.router.createUrlTree([`loading_order_details`, row.loading_id]));
    window.open(`#${link}`, '_blank');
  }

  public async navigateToUnloadingCommand(row, $event: Event): Promise<any> {
    $event.preventDefault();
    $event.stopPropagation();
    const link = this.router.serializeUrl(this.router.createUrlTree([`receiving_order_details`, row.unloading_id]));
    window.open(`#${link}`, '_blank');
  }

  public onContextMenu(event: MouseEvent, item: any): void {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = {item};
    this.contextMenu.menu.focusFirstItem('mouse');
    this.contextMenu.openMenu();
  }

  public openFilterTableDialog(): void {
    const filterTableDialogRef = this.matDialog.open(FilterTableDialogComponent, {
      data: {
        config: this.config
      },
      position: {
        right: '0'
      }
    });

    filterTableDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.localStorageService.setItem(`filterItem`, result, this.config.model);
        this.config = Object.assign({}, result.config);
        this.filterTableDialogFilter = result.filter;
        this.searchFilter = '';
        this.searchValue = '';
        this.setFilterValues();
        this.applyFilter();
      }
    });
  }

  public async openRowInAnewTab(row: any): Promise<any> {
    if (this.config.model === 'event_log' || this.config.model === 'event_log/agreement' || this.config.model === 'event_log/sale_point'
      || this.config.model === 'event_log/refrigerator') {
      const link = this.router.serializeUrl(this.router.createUrlTree([row.model, row.model_id]));
      window.open(`#${link}`, '_blank');
      // await this.router.navigate([row.model, row.model_id]);
    } else if (this.config.navigatePath) {

      if (this.config.model === 'promo_material_request/web') {
        await localStorage.setItem('promoDetails', JSON.stringify(row));
      }

      if (this.config.model === 'purchase_orders') {
        await localStorage.setItem('purchaseOrder', JSON.stringify(row));
      }
      if (this.config.model === 'loading_command/web' || this.config.model === 'unloading_command/web') {
        const details = {
          loading_order_id: row.command_id,
          order_id: row.id, // row id
          order_id1: row.order_id, // arithmos pareggelias
          order_type_id: row.order_type_id, // apo pou proerxetai p.x aitisi | paraggelia
          desired_delivery_date: row.desired_delivery_date,
          sale_point_id: row.sale_point_id,
          user_id: row.user_id,
          recipient: row.sale_point_name,
          address: row.sale_point_address,
          loading_command_total_canceled_quantity: +row.loading_command_total_canceled_quantity,
          loading_command_total_quantity: +row.loading_command_total_quantity,
          request_type_id: row.request_type_id, // an proerxetai p.x apo simeio pwlisis eparxias | simeio pwlisis idiou diktyou
          status: row.status_id ? row.status_id : null
        };
        await localStorage.setItem('orderDetails', JSON.stringify(details));
      }
      if (this.config.model === 'loading_command/web/details' || this.config.model === 'unloading_command/web/details') {
        const details = {
          order_id: this.orderDetails.order_id,
          material_id: row.material_id
        };
        await localStorage.setItem('orderDetailsSerials', JSON.stringify(details));
      }
      if (this.config.model === 'request/web') {
        const details = {
          requestId: row.id,
          status_id: row.status_description_id,
          type_id: row.type_id,
          sale_point_id: row.sale_point_id,
          sale_point_customer_name: row.sale_point_customer_name,
          sales_point_sales_group_name: row.sales_point_sales_group_name,
          sale_point_address: row.sale_point_address
        };
        localStorage.setItem('requestDetails', JSON.stringify(details));
      }
      if (this.config.model === 'return_command/web') {
        const details = {
          created_from_user_role_id: row.role_id,
          created_from_user_role_name: row.role_name,
          requestId: row.id,
          status_id: row.status_id,
          city: row.recipient_sale_point_city,
          recipient: row.recipient_sale_point_customer_name,
          typeId: row.type_id,
          cancel_reason_description: row.cancel_reason_description,
          cancel_reason_id: row.cancel_reason_id,
          applicant_name: row.applicant_sale_point_customer_name ? row.applicant_sale_point_customer_name : '-',
          applicant_sales_group: row.applicant_sale_point_sales_group ? row.applicant_sale_point_sales_group : '-',
          applicant_address: row.applicant_sale_point_address ? row.applicant_sale_point_address : '-',
          recipient_sales_group: row.recipient_sales_group ? row.recipient_sales_group : '-'
        };
        await localStorage.setItem('returnDetails', JSON.stringify(details));
      }

      const link = this.router.serializeUrl(this.router.createUrlTree([this.config.navigatePath, row[this.config.navigateProperty]]));
      window.open(`#${link}`, '_blank');
      // await this.router.navigate([this.config.navigatePath, row[this.config.navigateProperty]]);
    }
  }

  public removeAllFilters(): void {
    // this.loadingService.show();
    this.localStorageService.clearStorage(`filterItem_${this.config.model}`);
    this.config = Object.assign({}, this.tableFiltersService.removeAllFilters(this.config));
    this.filterTableDialogFilter = this.tableFiltersService.getFilter(this.config);
    this.setFilterValues();
    this.applyFilter();
  }

  public removeFilterChip(filterChip: Column): void {
    // this.loadingService.show();
    this.localStorageService.clearStorage(`filterItem_${this.config.model}`);
    this.config = Object.assign({}, this.tableFiltersService.removeFilter(this.config, filterChip));
    this.filterTableDialogFilter = this.tableFiltersService.getFilter(this.config);
    const filterModel = {
      config: this.config,
      filter: this.filterTableDialogFilter
    };
    this.localStorageService.setItem('filterItem', filterModel, this.config.model);
    this.setFilterValues();
    this.applyFilter();
  }

  private setFilterValues(): void {
    this.filterChips = [];

    this.filterValues = [];

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.config.columns.length; i++) {
      if (this.config.columns[i].type === Types.customSelect && this.config.columns[i].customSelected) {
        this.filterChips.push(this.config.columns[i]);

        let value: string;

        value = '';

        // tslint:disable-next-line:prefer-for-of
        for (let y = 0; y < this.config.columns[i].customSelected.length; y++) {
          value = `${value === '' ? value : `${value} ή `}${this.config.columns[i].customSelected[y].name}`;
        }

        this.filterValues.push({
          title: this.config.columns[i].title,
          value
        });
      } else if ((this.config.columns[i].type === Types.date || this.config.columns[i].type === Types.dateTime) &&
        (this.config.columns[i].fromValue || this.config.columns[i].toValue)) {
        this.filterChips.push(this.config.columns[i]);

        this.filterValues.push({
          title: this.config.columns[i].title,
          value: `${this.config.columns[i].fromValue ? this.commonService.formatDate(this.config.columns[i].fromValue) :
            this.commonService.formatDate(moment())} - ${this.config.columns[i].toValue ?
            this.commonService.formatDate(this.config.columns[i].toValue) : this.commonService.formatDate(moment())}`
        });
      } else if ((this.config.columns[i].type === Types.number) &&
        (this.config.columns[i].fromValue || this.config.columns[i].toValue)) {
        this.filterChips.push(this.config.columns[i]);

        this.filterValues.push({
          title: this.config.columns[i].title,
          value: `${this.config.columns[i].fromValue ? this.config.columns[i].fromValue : 0} - ${this.config.columns[i].toValue ? this.config.columns[i].toValue : 0}`
        });
      } else if ((this.config.columns[i].type === Types.select ||
          this.config.columns[i].type === Types.multipleSelect) && this.config.columns[i].selected &&
        this.config.columns[i].selected.length > 0) {
        this.filterChips.push(this.config.columns[i]);

        let value: string;

        value = '';

        // tslint:disable-next-line:prefer-for-of
        for (let y = 0; y < this.config.columns[i].selected.length; y++) {
          value = `${value === '' ? value : `${value} ή `}${this.config.columns[i].selected[y].name}`;
        }

        this.filterValues.push({
          title: this.config.columns[i].title,
          value
        });
      } else if (this.config.columns[i].type === Types.text && this.config.columns[i].text) {
        this.filterChips.push(this.config.columns[i]);

        this.filterValues.push({
          title: this.config.columns[i].title,
          value: this.config.columns[i].text.toUpperCase()
        });
      }
    }
  }

  public setIcon(value: any, column: any): string {
    return value[column.name.replace('_name', '_value')] === 0 ? 'cancel' : 'check_circle';
  }

  public setIconColor(value: any, column: any): string {
    return value[column.name.replace('_name', '_value')] === 0 ? '#dd0330' : '#4caf50';
  }

  public setSearchFilter(): void {
    const customFilters = this.getCustomFiltersFromLocalStorage();
    customFilters.searchValue = this.searchValue;
    customFilters.pagingFilter.index = this.searchValue && this.searchValue !== '' ? customFilters.pagingFilter.index : 0;
    this.localStorageService.setItem(`filterSortPaginatingItem`, customFilters, this.config.model);
    this.sort.active = customFilters.sortingFilter.columnName;
    this.sort.direction = customFilters.sortingFilter.direction;
    this.paginator.pageIndex = customFilters.pagingFilter.index;
    this.paginator.pageSize = customFilters.pagingFilter.size;
    // this.loadingService.show();

    this.searchFilter = '';

    const searchFields = this.config.searchFields.split(',');

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < searchFields.length; i++) {
      // this.searchFilter += `${searchFields[i]} LIKE '%${this.searchValue}%' COLLATE utf8_general_ci OR `;
      this.searchFilter += `${searchFields[i]} LIKE '%${this.searchValue}%' OR `;
    }

    this.searchFilter = encodeURI(this.searchFilter.slice(0, -4));
    this.applyFilter();
  }

  public setSelectedColumns(): void {
    this.localStorageService.setItem('selectedColumns', this.selectedColumns, this.config.model);
  }

  public setTableHeight(): number {
    return this.config.nested ? window.innerHeight - 503 : window.innerHeight - 330;
  }

  private setUpDisplayedColumns(): void {
    const columns = this.getSelectedColumns();
    if (columns) {
      this.selectedColumns = columns;
    } else {
      this.selectedColumns = this.config.columns;
    }
    this.isColumnSet = true;
  }

  public setValue(value: any, column: any): string {
    if (value[column.name] !== undefined) {
      return this.formatValue(value[column.name], column);
    } else {
      return '-';
    }
  }

  public showFilterChips(): boolean {
    return this.filterChips && this.filterChips.length > 0;
  }

  public showIcon(column: any): boolean {
    return (this.config.model === 'event_log' || this.config.model === 'event_log/agreement'
        || this.config.model === 'event_log/sale_point' || this.config.model === 'event_log/refrigerator')
      && (column.name === 'is_displayed_name' || column.name === 'is_done_name');
  }

  private toastMessages(message): void {
    this.matSnackBar.open(message, null, {
      duration: 3000
    });
  }

  public updateInventoryRefrigeratorSerial(element: any): void {
    const refrigerator = {
      id: element.id,
      serial_number: element.refrigerator_serial_number,
      action: 'update'
    };
    const refrigeratorUpdateDialog = this.matDialog.open(UpdateSerialNumberDialogComponent, {});

    refrigeratorUpdateDialog.afterClosed().subscribe(async (result) => {
      if (result) {
        refrigerator.serial_number = result;
        try {

          let existingRefrigerators = [];
          existingRefrigerators = await this.commonService.getSimpleList(`refrigerator/refrigerator2?filter=serial_number=${result}`) as [];

          if (existingRefrigerators.length > 0) {
            if (existingRefrigerators[0].sale_point_id) {

              const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
                data: {
                  title: 'Το ψυγείο βρίσκεται σε άλλη τοποθεσία',
                  message: `Το ψυγείο με σεριακό αριθμό ${result} υπάρχει ήδη στην τοποθεσία ${existingRefrigerators[0].sale_point_customer_name}. Θέλετε να το μεταφέρετε στην τρέχουσα τοποθεσία?`
                }
              });

              confirm.afterClosed().subscribe(async (confirmResult) => {
                if (confirmResult) {
                  try {
                    await this.updateRefrigeratorSerial(refrigerator);
                    this.toastMessagesService.toastMessages(`Η ενημέρωση ολοκληρώθηκε με επιτυχία`);

                  } catch (e) {
                    this.toastMessagesService.toastErrorMessage(e.message);
                  }
                } else {
                  const closeNotification = this.matDialog.open(SimpleConfirmActionDialogComponent, {
                    data: {
                      title: 'Ολοκλήρωση Ειδοποίησης',
                      message: `Θέλετε να θέσετε την ειδοποίηση για το ψυγείο με σεριακό αριθμό ${result} ως ολοκληρωμένη;`
                    }
                  });

                  closeNotification.afterClosed().subscribe(async (notificationResult) => {
                    if (notificationResult) {
                      try {
                        refrigerator.action = 'updateNotification';
                        await this.updateRefrigeratorSerial(refrigerator);
                        this.toastMessagesService.toastMessages(`Η ενημέρωση ολοκληρώθηκε με επιτυχία`);
                      } catch (e) {
                        this.toastMessagesService.toastErrorMessage(e.message);
                      }
                    } else {
                      this.toastMessagesService.toastMessages(`Ακυρώσατε την ενέργεια`);
                    }
                  });
                }
              });
            } else {
              try {
                await this.updateRefrigeratorSerial(refrigerator);
                this.toastMessagesService.toastMessages(`Η ενημέρωση ολοκληρώθηκε με επιτυχία`);

              } catch (e) {
                this.toastMessagesService.toastErrorMessage(e.message);
              }
            }
          } else {
            this.toastMessagesService.toastErrorMessage(`O σειριακός που πληκτρολογήσατε δεν υπάρχει`);
          }
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  public updateRefrigeratorFromLoading(element: any, edit: boolean): void {
    const type = 2;
    if (edit) {
      const dialogResult = this.matDialog.open(UpdateSerialNumberDialogComponent, {});

      dialogResult.afterClosed().subscribe(async (serialNumber) => {
        if (serialNumber) {
          const model = {} as UpdateEntities;
          model.type = type;
          model.id = element.id;
          model.value = serialNumber;
          try {
            await this.refrigeratorsService.updateRefrigeratorSerialNumber(model);
            this.toastMessages(`H ενημέρωση ολοκληρώθηκε με επιτυχία`);
            element.serial_number = serialNumber;
          } catch (e) {
            this.toastMessages(`H ενημέρωση απέτυχε. Λόγος: ${e.message}`);
          }
        }
      });
    } else {
      const dialogResult = this.matDialog.open(SimpleConfirmActionDialogComponent, {
        data: {
          title: 'Ενημέρωση σειριακού αριθμού',
          message: `Ειστε σίγουροι ότι ενημερώσατε τις πληροφορίες του ψυγείου για τον σειριακό αριθμό : ${element.serial_number}`
        }
      });

      dialogResult.afterClosed().subscribe(async (result) => {
        if (result) {
          const model = {} as UpdateEntities;
          model.type = type;
          model.id = element.id;
          model.value = element.serial_number;
          try {
            await this.refrigeratorsService.updateRefrigeratorSerialNumber(model);
            this.toastMessages(`H ενημέρωση ολοκληρώθηκε με επιτυχία`);
          } catch (e) {
            this.toastMessages(`H ενημέρωση απέτυχε. Λόγος: ${e.message}`);
          }
        }
      });
    }
  }

  private async updateRefrigeratorSerial(refrigerator): Promise<any> {
    try {
      await this.commonService.updateObject(`inventory/web/refrigerator`, refrigerator);
    } catch (e) {
      throw e;
    }
  }

  public async updateRefrigeratorSerialFromInventory(): Promise<any> {
    const model = {} as UpdateEntities;
    model.id = this.inventoryRefrigeratorRow.id;
    model.value = this.inventoryRefrigeratorSerialNumber;
    model.type = 1;

    try {
      await this.refrigeratorsService.updateRefrigeratorSerialNumber(model);
      this.toastMessages(`Η ενημέρωση σειριακού ολοκληρώθηκε με επιτυχία`);

      const refrigerator = this.data.find(record => record.id === this.inventoryRefrigeratorRow.id);
      refrigerator.refrigerator_serial_number = this.inventoryRefrigeratorSerialNumber;
      refrigerator.inventory_refrigerator_type_id = 4;
      refrigerator.inventory_refrigerator_type_name = 'ΕΙΣΗΓΜΕΝΟ';
    } catch (e) {
      this.toastMessages(`Η ενημέρωση σειριακού απέτυχε. Λόγος ${e.message}`);
    }
  }

  public async updateRefrigeratorSerialFromSAP(): Promise<any> {
    const model = {} as UpdateEntities;
    model.id = this.inventoryRefrigeratorRow.id;
    model.value = this.inventoryRefrigeratorRow.refrigerator_serial_number;
    model.type = 1;

    try {
      await this.refrigeratorsService.updateRefrigeratorSerialNumber(model);
      this.toastMessages(`Η ενημέρωση σειριακού ολοκληρώθηκε με επιτυχία`);

      const refrigerator = this.data.find(record => record.id === this.inventoryRefrigeratorRow.id);
      refrigerator.inventory_refrigerator_type_id = 4;
      refrigerator.inventory_refrigerator_type_name = 'ΕΙΣΗΓΜΕΝΟ';
    } catch (e) {
      this.toastMessages(`Η ενημέρωση σειριακού απέτυχε. Λόγος ${e.message}`);
    }
  }

  public userIsInRole(): boolean {
    return this.user.role_id === 1 || this.user.role_id === 10;
  }

  public userIsInRoleForLoadingCommand(): boolean {
    return this.user.role_id === 1 || this.user.role_id === 10 || this.user.role_id === 11;
  }
}
